import React from "react";
import { COUNTRY } from "../../../constants/CountryConstant";
import UploadFile from "../../employee/employee_import/UploadFile";
import Confirm2 from "../../import_export/import/steps/Confirm2";
import Mapper2 from "../../import_export/import/steps/MatchHeader2";
import StepsManager from "../../import_export/import/StepsManager";
import ImportService from "../../import_export/service/Import";

export default class ComponentImportManager {
    static getAllCreationSteps(onClickHandler) {
        return [
            {
                title: "Upload File",
                requiredProps: [],
                reqError: "Please upload a file to continue",
                getChild: (props) => (
                    <UploadFile
                        {...props.state}
                        generateAuditLog={ComponentImportManager.generateAuditLog}
                        fileInfo={props.state.fileInfo}
                        setData={props.setData}
                        tableName={props.tableName}
                    />
                ),
                onClick: (event) => onClickHandler(event, 0),
            },

            {
                title: "Map Columns",
                requiredProps: ["fileContent"],
                reqError: "Please map/skip the unmapped columns to continue",
                getChild: (props) => (
                    <Mapper2
                        {...props.state}
                        setData={props.setData}
                        tableName={props.tableName}
                        generateNewColumn={StepsManager.createNewColumn}
                        setTableColumns={StepsManager.setTableColumns}
                        systemHeaders={StepsManager.getColumns(props.tableName, props.state)}
                    />
                ),
                onClick: (event) => onClickHandler(event, 1),
            },
            {
                title: "Confirm Import",
                requiredProps: ["mappedHeaders"],
                reqError: "Please check for invalid records",
                getChild: (props) => (
                    <Confirm2
                        {...props.state}
                        setData={props.setData}
                        tableName={props.tableName}
                        backStepHandler={(e) => onClickHandler(e, 1)}
                        confirmationHandler={(e) => onClickHandler(e, 3)}
                        segmentValues={StepsManager.getSegmentColumn(
                            props.tableName,
                            props.state.jobPipelines
                        )}
                        tableColumns={StepsManager.getColumns(props.tableName, props.state)}
                    />
                ),
                onClick: (event) => onClickHandler(event, 2),
            },
        ];
    }

    static async generateAuditLog(file) {
        const filePath = await ComponentImportManager.getUploadFileRelativeURL(
            file
        );
        const columnMapping = await ImportService.getColumnMapping({
            relativeFilePath: filePath,
            module: "PEOPLE_COMPONENT",
        });
        return { filePath, columnMapping };
    }

    static async getUploadFileRelativeURL(file) {
        const fileUploadResponse = await ImportService.getUploadFileURL(
            file,
            "IMPORT_PEOPLE_COMPONENT"
        );
        return fileUploadResponse.relativePath;
    }

    static FilterComponents(mapping, components, country) {
        const filteredMapping = [];
        if (Array.isArray(mapping)) {
            mapping.forEach((map) => {
                const component = components?.find((c) => c.id === map.id);
                if (component) {
                    if (country === COUNTRY.IN) {
                        if (component.isActive && !component.isFormula && component.subType !== "fixed_allowance") {
                            filteredMapping.push(map);
                        }
                    } else {
                        if (component.isActive && !component.isFormula) {
                            filteredMapping.push(map);
                        }
                    }
                } else {
                    filteredMapping.push(map);
                }
            });
        }

        return filteredMapping;
    }
}
